import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const warehouseApi = createApi({
  reducerPath: 'warehouseApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/common/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["Warehouse"],
  endpoints: (builder) => ({
    getWarehouse: builder.query({
      query: (employeeGuid) => {
        return {
          url: `warehouse`,
          params: {
            employeeGuid: employeeGuid
          }
        }
      },
      providesTags: ["Warehouse"],
    }),
    createOrUpdateWarehouse: builder.mutation({
      query: (formData) => {
        return {
          url: `warehouse`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ['Warehouse'],
    }),
    givePermission: builder.mutation({
      query: (formData) => {
        return {
          url: `warehouse-user`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ['Warehouse'],
    }),
    addWarehouse: builder.mutation({
      query: (data) => ({
        url: 'warehouse-user',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Warehouse'],
    }),
    deleteWarehouse: builder.mutation({
      query: ({ id }) => ({
        url: `warehouse/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Warehouse'],
    }),
  }),
})

export const { useGetWarehouseQuery, useCreateOrUpdateWarehouseMutation, useAddWarehouseMutation, useDeleteWarehouseMutation, useGivePermissionMutation } = warehouseApi